var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasImages)?_c('lazy-image',{staticClass:"responsive-image",attrs:{"description":_vm.description,"url":_vm.url}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }